import { z } from 'zod';
import { MEMBERSHIP_TYPE, MEMBERSHIP_PRICE_TYPE, USER_MEMBERSHIP_STATUS } from '../enums/membership.enum';

export const MembershipSchema = z.object({
   id: z.string(),
   type: z.nativeEnum(MEMBERSHIP_TYPE),
   name: z.string(),
   description: z.string().nullable(),
   stock: z.number().nullable(),
   monthlyBalls: z.number(),
   monthlyNftRents: z.number(),
   multiplier: z.number(),
   prices: z
      .array(
         z.object({
            type: z.nativeEnum(MEMBERSHIP_PRICE_TYPE),
            price: z.number(),
            discount: z.number().nullable(),
         })
      )
      .nullable()
      .optional(),
});

export const UserMembershipSchema = z.object({
   id: z.string(),
   membership: MembershipSchema.nullable(),
   status: z.nativeEnum(USER_MEMBERSHIP_STATUS),
   type: z.nativeEnum(MEMBERSHIP_PRICE_TYPE),
   price: z.number(),
   discount: z.number().nullable(),
   monthlyBalls: z.number(),
   monthlyNftRents: z.number(),
   multiplier: z.number(),
   origin: z.string().nullable(),
});
